<template>
	<div>
		<action-sidebar
			title="Duplicar Rol"
			:value="true"
			@close-modal="closeModal"
		>
			<role-duplicate-form
				:role-id="id"
				:role-name="name"
			/>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import roleDuplicateForm from '@/components/roles/role-duplicate-form';

function closeModal() {
	this.goTo('page-role', { params: { codeCompany: this.codeCompany, codeProject: this.codeProject } });
}

export default {
	name: 'page-role-duplicate',
	components: {
		actionSidebar,
		roleDuplicateForm,
	},
	methods: {
		closeModal,
	},
	props: {
		codeCompany: {
			required: true,
			type: String,
		},
		codeProject: {
			required: true,
			type: String,
		},
		id: {
			required: true,
			type: [Number, String],
		},
		name: {
			type: String,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/roles/page-role-duplicate.vue